<ng-container *ngIf="hasError">
  <ng-container *ngFor="let error of errorMessages | keyvalue">
    <div id="{{ error.key }}" class="alert alert-danger fade show" role="alert">
      {{ error.value }}
    </div>
  </ng-container>
</ng-container>
